module.exports = __webpack_public_path__ + "img/AI (1).acaed67e.png";